module.exports = __webpack_public_path__ + "static/media/token_black.c0f41ef9.png";